import React from 'react';
import PropTypes from 'prop-types';
import url from 'url';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Redirect from '../../../../common/components/Redirect';
import CurrentUserActions from '../../../../redux-modules/current-user';
import { LOCATION_ORIGIN } from '../../../../common/call-api';
import CustomerActions from '../../actions/customers';
import LoginRedirect from '../LoginRedirect';
import OrganizationActions from '../../actions/organizations';
import ActionHandler from '../ActionHandler';

const RedirectInvalidUser = () => {
  const currentUrl = url.parse(window.location.href);
  return <LoginRedirect returnUrl={currentUrl.pathname} />;
};

class OnboardingAuth extends React.Component {
  static propTypes = {
    currentUser: PropTypes.shape({
      id: PropTypes.string,
      token: PropTypes.string,
    }),
    location: PropTypes.shape({
      query: PropTypes.shape({
        email: PropTypes.string,
        memid: PropTypes.string,
      }),
    }),
    steps: PropTypes.arrayOf(PropTypes.shape({ url: PropTypes.string })),
    activeIndex: PropTypes.number,
    setActiveIndex: PropTypes.func,
  };

  componentWillReceiveProps(nextProps) {
    const {
      currentCustomer,
      location: { query },
      currentUser,
      actions,
    } = this.props;
    if (!currentCustomer && !!nextProps.currentCustomer) {
      // when we get customer
      if (
        query.email &&
        currentUser &&
        currentUser.id &&
        currentUser.token &&
        nextProps.currentCustomer.key !== currentUser.id
      ) {
        // if query customer is different than logged in user
        actions.currentUser.clearAuth();
      }
    }
  }

  handleOrgResult = currentCustomer => orgResult => {
    const {
      currentUser,
      location: { query },
      steps,
      activeIndex,
      setActiveIndex,
      goForward,
    } = this.props;
    const currentStep = steps[activeIndex];

    if (
      orgResult &&
      orgResult.hasError &&
      orgResult.status &&
      orgResult.status === 404
    ) {
      return <RedirectInvalidUser />;
    }

    if (orgResult && !orgResult.hasError) {
      const { credentials = {}, contactDetails: { emailAddress } = {} } =
        currentCustomer || {};
      const { payload: { json: org } } = orgResult;
      const { id } = org || {};

      if (currentUser.token) {
        // if user is already logged in, they shouldn't be able to access create pw
        if ((currentStep.url || '').toLowerCase().includes('password')) {
          goForward();
        }
        // prevent logging in if already logged in
        return null;
      }

      if (!query.memid || id.toString() !== query.memid) {
        // if non authed user is missing any query params, or memid doesn't match
        return <RedirectInvalidUser />;
      }

      // user is valid and unauthenticated
      if (credentials.isPasswordSet) {
        // require login if pw exists and skip step 1
        const returnUrl = `returnUrl=/account/onboarding`;
        const message = 'message=Please enter your password to continue.';
        const email = emailAddress ? `email=${emailAddress}` : '';
        return (
          <Redirect
            to={`${LOCATION_ORIGIN}/auth/login?${returnUrl}&${message}&${email}`}
          />
        );
      } else if (
        !((currentStep || {}).url || '').toLowerCase().includes('password')
      ) {
        // if user needs to create a pw and is not on the pw step
        setActiveIndex(0);
      }
    }
    return null;
  };
  handleCustomerResult = custResult => { 
    const { actions, location:  {query} } = this.props;

    if(query && query.eFedTokenKey){
      return null
    }

    if (
      custResult &&
      custResult.hasError &&
      custResult.status &&
      custResult.status === 404
    ) {
      return <RedirectInvalidUser />;
    }

    if (custResult && !custResult.hasError) {
      const { payload: { json: customer } } = custResult;
      const { key } = customer.organization || {};

      if (!customer.organization || !key) {
        return <RedirectInvalidUser />;
      }

      return (
        <ActionHandler action={actions.organization.get} data={[key]}>
          {this.handleOrgResult(customer)}
        </ActionHandler>
      );
    }

    return null;
  };

  render() {
    const {
      currentCustomer,
      currentUser,
      location: { query },
      actions,
    } = this.props;

    const customerFetchParam = query.email
      ? ['', { params: { email: query.email } }]
      : [currentUser.id];

    return (
      <ActionHandler
        condition={!currentCustomer && (!!query.email || !!currentUser.id)}
        action={actions.customer.get}
        data={customerFetchParam}
      >
        {this.handleCustomerResult}
      </ActionHandler>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      currentUser: bindActionCreators(CurrentUserActions, dispatch),
      customer: bindActionCreators(CustomerActions, dispatch),
      organization: bindActionCreators(OrganizationActions, dispatch),
    },
  };
};

export default connect(null, mapDispatchToProps)(OnboardingAuth);



// WEBPACK FOOTER //
// ./src/App/account/components/Onboarding/OnboardingAuth.js